import React from 'react';
import '../template-file-css/document-file-template.css';



export const LHH_LegalGuardianshipAssignBenefits = ({
    itemsRef,
    showErrorFor,

}) => {

    return (
        <form id='LHH_LegalGuardianshipAssignBenefits' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'>
                    <ul>
                        <li>Lilly Pad Home Health LLC</li>
                        <li>103 MillCreek Corners Brandon, MS 39047</li>
                        <li>Lillypadhomehealth@yahoo.com</li>
                    </ul>
                </p>

                <p className='w-750'><h3>Legal Guardianship Assignment of Benefits and Authorization</h3></p>
                <p className='w-750'>
                    My signature below indicates the following:
                </p>
                <p className='w-750'>
                    I am the legal guardian of &nbsp;
                    <input type='text' name='txtMedication' id='txtMedication' className='add-only w-350 custom-add-only' />
                </p>
                <p className='w-750'>
                    {`[He/She is not in the custody of the state, or any other court appointed entity.]`}
                </p>
                <p className='w-750'>
                    My privileges to sign on behalf of the child have not been forfeited.
                </p>
                <p className='w-750'>
                    In the event that I am unable to attend my child's doctor's appointments, I would like to designate the 
                    following person as my health care surrogate. I understand that my health care surrogate will have the ability 
                    to attend my child's appointments on my behalf.
                </p>

                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>First Name:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Last Name:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Relationship:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' name='txtFirstName' id='txtFirstName' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' name='txtLastName' id='txtLastName' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' name='txtRelationship' id='txtRelationship' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Address:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>City:</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Zip:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' name='txtAddress' id='txtAddress' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' name='txtCity' id='txtCity' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <input type='text' name='txtZip' id='txtZip' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Telephone Number:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' name='txtTelephone' id='txtTelephone' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    This authorization will expire one year from signature date: &nbsp;
                    <input type='date' name='txtTelephoneDate' id='txtTelephoneDate' className='add-only w-200 custom-add-only' /> &nbsp;
                    or the following date: &nbsp;
                    <input type='date' name='txtTelephoneDate1' id='txtTelephoneDate1' className='add-only w-200 custom-add-only' />
                </p>

                <table>
                    <tr>
                        <td className='signature w-450'></td>
                        <td className='signature w-250'></td>
                    </tr>
                    <tr>
                        <td className='small w-450'>Authorized persons signature:</td>
                        <td className='small w-250'>DOB:</td>
                    </tr>
                </table>


                <p className='w-750'>
                    <b>Assignment of Benefits</b>
                </p>
                <p className='w-750'>
                    I understand that for anyone to directly bill Medicare, Medicaid, or other insurance carriers for my inpatient/outpatient 
                    medical care, I must give permission. I hereby assign, transfer and set over unto Louisiana Department of Health and 
                    Hospitals/The Creed Group, as its interest may appear all medical benefits now or becoming due to me under the terms of 
                    any third-party insurance coverage that I currently am entitled to or that I become entitled to in the future. I hereby 
                    direct any third-party insurance entity whose benefits are now due or become due to me pay benefits directly to the named 
                    agency for services provided by the clinic. I understand that the information contained in a medical record is confidential.
                     However, I specifically give consent for Louisiana Department of Health and Hospitals/The Creed Group to release medical information 
                     to Medicare, Medicaid, or other insurance carriers on my behalf.
                </p>
                <p className='w-750'>
                    Parent/Guardian: &nbsp;<input type='text' name='txtGuardian' id='txtGuardian' className='add-only w-250 custom-add-only' />
                </p>

                <table>
                    <tr>
                        <td className='signature w-450'></td>
                        <td className='signature w-250'></td>
                    </tr>
                    <tr>
                        <td className='small w-450'>Signature:</td>
                        <td className='small w-250'>Date</td>
                    </tr>
                </table>


            </div>
        </form >

    )
}











